// extracted by mini-css-extract-plugin
module.exports = {"campaignLabel":"CampaignLabel_campaignLabel__LcVqW"};